import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }: { children: React.JSX.Element }) => {
  const { data = {} } = useSelector((state: any) => state.user);

  return data.access_token ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;